import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const PowerBILogoBackplate16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M0 0h2048v2048H0V0z" />
    </svg>
  ),
  displayName: 'PowerBILogoBackplate16Icon',
});

export default PowerBILogoBackplate16Icon;
